<template>
  <v-app class="d-block">
    <BaseAlert />

    <HeaderSPILPrime />
    <NuxtPage />
    <Footer />
  </v-app>
</template>

<script>
export default {
  name: "SPILPrimeLayout",
};
</script>
